import styled from 'styled-components/macro';
import { ThreeBounce } from 'better-react-spinkit';

import * as colors from 'components/common/colorConstants';

export const PopupWrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 354px;
  min-height: 100px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 35px -9px rgba(0, 0, 0, 0.37);
  background-color: ${colors.purple1};
  color: ${colors.whiteText};
  font-family: Roboto, sans-serif;
  transition: 0.5s;

  &:before {
    content: '';
    position: absolute;
    display: block;
    height: 0px;
    width: 0px;
    top: 20px;
    left: -14px;
    border-width: 7px;
    border-color: transparent ${colors.purple1} transparent transparent;
    border-style: solid;
  }

  animation-name: grow;
  animation-direction: forwards;
  animation-duration: 0.5s;

  @keyframes grow {
    0% {
      width: 300px;
      height: 80px;
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    100% {
      width: 345px;
      height: 100px;
    }
  }
`;

export const BouncingDotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

export const Messages = styled.div`
  background-color: ${colors.purple1};
  flex-grow: 1;
  width: 100%;
`;

export const Header = styled.header`
  padding: 14px 16px 0;
  display: flex;
  align-items: center;
  font-family: Roboto, sans-serif;
`;

export const HeadingBold = styled.h3`
  margin: 0 0 2px;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.whiteText};

  > span {
    :nth-of-type(1) {
      padding-right: 10px;
      border-right: 1px solid ${colors.whiteText};
    }

    :not(:nth-of-type(1)) {
      padding-left: 8px;
    }
  }
`;

export const Timestamp = styled.div`
  margin-left: auto;
  margin-right: 0;
  color: ${colors.purple4};
  font-family: Roboto, sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
`;

export const MessageWrapper = styled.div`
  padding: 14px 16px 11px;
  border-bottom: 2px solid ${`${colors.purple4}4D`};
  overflow: hidden;

  &:first-of-type {
    padding-top: 0;
  }
`;

export const MessageText = styled.p`
  position: relative;
  margin: 0;
  padding: 0;
  max-height: 32px; // For truncating multi-line text, this must be a multiple of the line-height.
  overflow: hidden;
  color: ${colors.purple4};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  line-height: 16px;

  &::before {
    content: '...';
    position: absolute;
    inset-block-end: 0; // bottom
    inset-inline-end: 0; // right
  }

  &::after {
    content: '';
    position: absolute;
    inset-inline-end: 0; // right
    width: 11px;
    height: 11px;
    background: ${colors.purple1};
  }
`;

export const Actions = styled.div`
  padding: 11px 16px 16px;
`;

export const CtaText = styled.p`
  margin: 0;
  padding: 0;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  line-height: 18px;
  color: ${colors.purple4};

  > span {
    color: ${colors.whiteText};
    font-weight: 500;
  }
`;

export const CtaButtonWrapper = styled.div`
  width: 100%;
  padding-top: 11px;
`;

export const QuickReplyButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const QuickReplyButton = styled.button`
  display: grid;
  place-content: center;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 6px 10px;
  border: 1px solid ${colors.whiteText};
  border-radius: 3px;
  width: 130px;
  min-height: 40px;
  background-color: ${(props) => (props.selected ? colors.baseBackground : colors.purple1)};
  color: ${(props) => (props.selected ? colors.purple1 : colors.white)};
  font-family: Roboto, sans-serif;
  font-size: 10px;
  line-height: 14px;
  text-align: left;
  transition: background-color 0.3s linear, color 0.3s linear;
  cursor: pointer;

  ${(props) =>
    !props.loading &&
    `
  :hover {
    background-color: ${colors.baseBackground};
    color: ${colors.purple1};
  }
`};
`;

export const PurpleCircle = styled.div`
  height: 18px;
  width: 18px;
  border-radius: 9px;
  border: 0px;
  padding: 0px;
  background-color: ${colors.purple1};
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const Dots = styled(ThreeBounce)`
  position: relative;
  left: -1px;
`;

export const DismissButtonWrapper = styled.div`
  padding-top: 8px;
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: initial;
  color: ${(props) => (props.altStylesActive ? colors.whiteText : colors.purple1)};
  background: ${(props) => (props.altStylesActive ? colors.purple1 : colors.baseBackground)};
  border: 1px solid ${colors.whiteText};
  border-radius: 3px;
  width: 70px;
  height: 25px;
  margin-right: 7px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  outline: none;
  cursor: pointer;
`;
